// main.js

import Chart from 'chart.js/auto';
import Annotation from 'chartjs-plugin-annotation';
import moment from 'moment/dist/moment';
import 'moment/dist/locale/de';
import 'chartjs-adapter-moment';
import '../../styles/main/main.scss';
import './modals.js';
import './dateControls.js';
import './charts.js';
import './dataTables.js';
import './latestData.js';
import './calendar.js';
import './bulmaNavigation.js';
import './autarkyBadge.js';
import './forecast-chart-plugin.js';
import './battery-scenario.js';

import { updateDateData } from './dateControls.js';

// Make Chart and moment available globally (used throughout the script below).
window.Chart = Chart;
window.moment = moment;

// Register annotation plugin.
Chart.register(Annotation);

// Set `chart` defaults.
Chart.defaults.backgroundColor = 'rgb(72, 199, 142)';
Chart.defaults.borderColor = '#333';
Chart.defaults.color = '#ccc';

// Set `moment` defaults.
moment.locale('de');

// Initial update on page load — only if date controls are present.
if (updateDateData !== null) {
  updateDateData('date-change');
}
